import * as api from "../transport/api/memory-api.js";
import * as store from "./stores/memory-store.js";

export async function loadMemoryItems() {
  store.beginLoad();
  try {
    store.setItems(await api.listMemoryItems({ includeProposed: true, limit: 100 }));
  } catch (error) {
    store.setError(error);
  }
}

export async function updateMemoryStatus({ memoryId, status }) {
  await api.updateMemoryStatus({ memoryId, status });
  await loadMemoryItems();
}

export { store as memoryStore };
